import { getWhitelabelConfig, isNativeRuntime, isVriApp } from '../base/whitelabel/functions';
export function selectMeetingHost(domains, vriApp) {
    if (vriApp) {
        return domains.clientVri || domains.clientVrs || domains.api || domains.queue;
    }
    return domains.clientVrs || domains.clientVri || domains.api || domains.queue;
}
export function buildTenantRoomUrl(roomName, host) {
    const normalizedRoomName = roomName.trim();
    const normalizedHost = host.replace(/^https?:\/\//, '').replace(/\/+$/, '');
    if (!normalizedRoomName || !normalizedHost) {
        throw new Error('A room name and tenant meeting host are required.');
    }
    return `https://${normalizedHost}/${encodeURIComponent(normalizedRoomName)}`;
}
/**
 * Native has no same-origin meeting host, so a bare room name falls through
 * to meet.jit.si. Always qualify Malka rooms with the active tenant host.
 */
export function getRoomNavigationTarget(roomName) {
    if (!isNativeRuntime()) {
        return roomName;
    }
    const domains = getWhitelabelConfig()?.domains || {};
    const host = selectMeetingHost(domains, isVriApp());
    if (!host) {
        throw new Error('The active tenant has no meeting host configured.');
    }
    return buildTenantRoomUrl(roomName, host);
}
